import { isConsumerApp } from '@loggi/js/mobile';
import { createBridge } from '@loggi/js/mobile/bridge';
import Col from '@loggi/ui/components/col';
import Divider from '@loggi/ui/components/divider';
import Text from '@loggi/ui/components/text';
import colors from '@loggi/ui/components/utils/colors';
import View from '@loggi/ui/components/view';
import PropTypes from 'prop-types';
import React from 'react';
import { FOOTER_PACKAGE_TRACKING } from 'tracker.constants';
// Mobile
import { OPEN_EXTERNAL_LINK } from '../../public-tracker.bridges';
import styles from './package-tracking-footer.styles.scss';

export class PackageTrackingFooter extends React.Component {
  static propTypes = {
    isSmallScreen: PropTypes.bool.isRequired
  };

  _sendWebviewMessage = () => {
    const openExternalLinkBridge = createBridge(OPEN_EXTERNAL_LINK);
    openExternalLinkBridge[OPEN_EXTERNAL_LINK]({
      url: FOOTER_PACKAGE_TRACKING.linkUrl
    });
  };

  render() {
    const { isSmallScreen = false } = this.props;
    return (
      <View inline>
        <Divider color={colors.type.LIGHTER} gutter="normal" />
        <Col
          gutter={
            isSmallScreen
              ? {
                  top: 'normal',
                  left: 'triple',
                  right: 'triple',
                  bottom: 'normal'
                }
              : { top: 'normal', bottom: 'normal' }
          }
          justifyContent="center"
          className={isSmallScreen ? styles.textAlign : ''}
        >
          <Text small bold color={colors.type.DARK}>
            {FOOTER_PACKAGE_TRACKING.textContent}
            <a
              href={FOOTER_PACKAGE_TRACKING.linkUrl}
              onClick={() => isConsumerApp() && this._sendWebviewMessage()}
              target="_blank"
              rel="noopener noreferrer"
            >
              {FOOTER_PACKAGE_TRACKING.linkLabel}
            </a>
          </Text>
        </Col>
      </View>
    );
  }
}

PackageTrackingFooter.displayName = 'PackageTrackingFooter';

export default PackageTrackingFooter;
